var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveBond(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FBBC05"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1825)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6374 18.4416C22.6485 17.7782 23.6436 17.0286 24.4978 16.1641C25.2498 15.4032 26.1327 14.2884 26.3076 13.1894C26.5523 11.6485 25.3369 10.1364 23.743 10.1364C22.9377 10.1364 22.1946 10.5658 21.7056 11.2021L21.6379 11.2906L21.5702 11.2021C21.0807 10.5664 20.3376 10.1369 19.5323 10.1369C17.9384 10.1369 16.723 11.6491 16.9677 13.1899C17.1425 14.289 18.0255 15.4038 18.7775 16.1646C19.6316 17.0286 20.6267 17.7788 21.6379 18.4421L21.6374 18.4416Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4764 21.9945L16.0139 28.2166C16.1382 28.4353 16.0638 28.7177 15.8485 28.8445L14.2157 29.8021C14.0004 29.9283 13.7223 29.8528 13.5975 29.6335L10.06 23.4114C9.93568 23.1927 10.01 22.9103 10.2254 22.7835L11.8581 21.826C12.0735 21.6997 12.3515 21.7752 12.4764 21.9939V21.9945ZM16.0916 20.7827L13.3438 22.3935L16.1432 27.3177L16.8408 26.9085L21.3423 28.1332C21.9999 28.3125 22.6299 28.2279 23.2198 27.8824L29.3169 24.3075C29.9673 23.9259 30.1921 23.0738 29.8169 22.4132C29.4412 21.7527 28.6021 21.5244 27.9516 21.9054L24.7049 23.8087C24.3836 24.826 23.6477 25.5108 22.5466 25.211L19.7889 24.4608C19.6413 24.4208 19.553 24.2664 19.5924 24.1164C19.6318 23.9665 19.7839 23.8769 19.9315 23.9169L22.6892 24.6671C23.4251 24.8672 23.9435 24.418 24.1244 23.7309C24.3314 22.9475 23.8702 22.1371 23.0988 21.9274L17.968 20.5314C17.3098 20.3527 16.6804 20.4367 16.0905 20.7822L16.0916 20.7827ZM11.8587 23.0676C11.5618 23.0676 11.3209 23.3122 11.3209 23.6137C11.3209 23.9152 11.5618 24.1598 11.8587 24.1598C12.1556 24.1598 12.3965 23.9152 12.3965 23.6137C12.3965 23.3122 12.1556 23.0676 11.8587 23.0676Z",
    fill: "#151515"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 19.726,
    fill: "white",
    transform: "translate(10 10.137)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveBond);
export default __webpack_public_path__ + "static/media/ActiveBond.e58a291b84c104ee9bc5faa4ecb67009.svg";
export { ForwardRef as ReactComponent };